import { OverflowMenu } from '@getsynapse/design-system';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { DashboardContext } from '../../DashboardContext';
import { ExportPdfOverflowMenuItem } from './ExportPdfOverflowMenuItem';
import { EditNameOverflowMenuItem } from './EditNameOverflowMenuItem';
import { DeleteDashboardOverflowMenuItem } from './DeleteDashboardOverflowMenuItem';
import { dashboardSelectors } from 'state/normalized/dashboard/dashboardSlice';
import { RootState } from 'state/store';

export const DashboardContentViewOverflowMenu = (props: { gridRef: any }) => {
  const { gridRef } = props;

  const { dashboardId } = useContext(DashboardContext);
  const { canEdit, canDelete } = useSelector((state: RootState) =>
    dashboardSelectors.selectDashboardAffordanceFlags(state, dashboardId)
  );

  return (
    <>
      <OverflowMenu
        menuListProps={{
          'data-cy': `dashboard-${dashboardId}__actions-popover`,
        }}
        menuButtonProps={{
          'data-cy': `dashboard-${dashboardId}__actions-popover-trigger`,
        }}
      >
        <ExportPdfOverflowMenuItem gridRef={gridRef} />
        {canEdit && <EditNameOverflowMenuItem />}
        {canDelete && <DeleteDashboardOverflowMenuItem />}
      </OverflowMenu>
    </>
  );
};
